import { push } from "connected-react-router";
import Avatar from "pages/_components/Avatar";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, func, shape, string } from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { actions as comexActions } from "reducers/comex";

const ContactItem = ({ contact, isDesktop, handleOpenDeleteForm, setContactToDelete }) => {
    const dispatch = useDispatch();

    const transfer = () => {
        dispatch(
            comexActions.setComexTransfer({
                contactDestination: {
                    ...contact,
                },
            }),
        );
        dispatch(push(`/comex/concept`));
    };

    const options = [
        {
            text: "comex.contact.contextMenu.transfer",
            textType: "I18N",
            func: () => {
                transfer();
            },
        },
        {
            text: "comex.contact.contextMenu.modify",
            textType: "I18N",
            func: () => {
                dispatch(push(`/comex/contact/modify/${contact.idContactDestination}`));
            },
        },
        {
            text: "comex.contact.contextMenu.delete",
            textType: "I18N",
            func: () => {
                setContactToDelete(contact);
                handleOpenDeleteForm();
            },
        },
    ];

    return (
        <>
            <GridTable.Data className="avatar-name ellipsis m-auto">
                <Avatar
                    user={{
                        userFullName: contact.recipientName,
                        defaultAvatarId: 0,
                        email: contact.recipientEmail,
                    }}
                />
                <CustomText text={contact.recipientName} textType="TEXT" className="contact-name ellipsis" />
            </GridTable.Data>
            <GridTable.Data className="ellipsis cbucvu">
                <CustomData
                    dataClass="ellipsis"
                    titleText="comex.contact.swift.aba.label"
                    titleTextType="I18N"
                    valueText={contact.number}
                    valueClass="ellipsis"
                />
            </GridTable.Data>

            <GridTable.Data className="menu">
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
            <GridTable.Data className="recipientName ellipsis">
                <CustomData
                    titleText="comex.contact.holder.label"
                    titleTextType="I18N"
                    valueText={contact.recipientName}
                    dataClass="ellipsis"
                    valueClass="ellipsis"
                />
            </GridTable.Data>
            <GridTable.Data className="recipientEmail ellipsis">
                <CustomData
                    titleText="comex.contact.currency.label"
                    titleTextType="I18N"
                    valueText={contact.currency}
                    dataClass="ellipsis"
                    valueClass="ellipsis"
                />
            </GridTable.Data>
        </>
    );
};

ContactItem.propTypes = {
    isDesktop: bool.isRequired,
    contact: shape({
        name: string,
        recipientName: string,
        recipientDocumentType: string,
        recipientDocumentNumber: string,
        currency: string,
    }).isRequired,
    handleOpenDeleteForm: func.isRequired,
    setContactToDelete: func.isRequired,
};

export default ContactItem;
